import React from "react";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
export default function LegalNotice() {
  const legalSections = [{
    index: "01",
    title: "Angaben gemäß § 5 DDG",
    content: <div className="space-y-1">
          <p className="text-foreground font-bold">CarFlowDE</p>
          <p className="text-muted-foreground">Inhaber: Christian Launert</p>
          <p className="text-muted-foreground">Rampe 5</p>
          <p className="text-muted-foreground">06295 Lutherstadt Eisleben</p>
          <p className="text-muted-foreground">Deutschland</p>
        </div>
  }, {
    index: "02",
    title: "Kontakt",
    content: <div className="space-y-3">
          <div className="flex items-center gap-3">
            <span className="text-muted-foreground">Telefon: +49 1516 840 5221</span>
          </div>
          <div className="flex items-center gap-3">
            <Link to="mailto:carflowde@gmail.com" className="text-primary hover:text-primary/80 transition-colors">
              E-Mail: carflowde@gmail.com
            </Link>
          </div>
        </div>
  }, {
    index: "03",
    title: "Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV",
    content: <div className="space-y-1">
          <p className="text-foreground font-bold">Christian Launert</p>
          <p className="text-muted-foreground">Rampe 5</p>
          <p className="text-muted-foreground">06295 Lutherstadt Eisleben</p>
          <p className="text-muted-foreground">Deutschland</p>
        </div>
  }, {
    index: "04",
    title: "Verbraucherstreitbeilegung",
    content: <div className="space-y-4">
          <p className="text-muted-foreground">
            Wir sind nicht verpflichtet und nicht bereit, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
          </p>
        </div>
  }, {
    index: "05",
    title: "Haftung für Inhalte",
    content: <p className="text-muted-foreground">Wir sind als Diensteanbieter für die eigenen Inhalte auf dieser Website nach den geltenden gesetzlichen Vorschriften verantwortlich. Trotz sorgfältiger Erstellung und regelmäßiger Überprüfung übernehmen wir keine Gewähr für die Aktualität, Vollständigkeit oder Richtigkeit der bereitgestellten Informationen. Gesetzliche Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.</p>
  }, {
    index: "06",
    title: "Haftung für Links",
    content: <p className="text-muted-foreground">Unsere Website enthält Links zu externen Websites Dritter. Auf deren Inhalte haben wir keinen Einfluss. Deshalb übernehmen wir für diese Inhalte keine Gewähr. Für die Inhalte der verlinkten Seiten ist ausschließlich der jeweilige Anbieter oder Betreiber verantwortlich. Zum Zeitpunkt der Verlinkung waren keine rechtswidrigen Inhalte erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Sollten uns Rechtsverletzungen bekannt werden, werden wir entsprechende Links unverzüglich entfernen.</p>
  }, {
    index: "07",
    title: "Urheberrecht",
    content: <p className="text-muted-foreground">
          Die durch den Seitenbetreiber erstellten Inhalte und Werke auf dieser Website unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechts bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
        </p>
  }];
  return <section id="legalnotice" className="w-full bg-background py-24 md:py-32 overflow-hidden">
      <div className="container mx-auto px-6">
        <div className="mb-20 max-w-3xl mx-auto">
          <h1 className="font-default text-5xl md:text-7xl font-bold tracking-tighter text-foreground mb-6">
            Impressum
          </h1>
          
        </div>

        <div className="max-w-3xl mx-auto space-y-16">
          {legalSections.map((section, i) => <div key={i} data-index={i} className="relative group">
              <div className="flex flex-col gap-4">
                <h2 className="font-default text-xl font-bold text-foreground uppercase tracking-tight">
                  {section.title}
                </h2>
                <div className="text-base leading-relaxed">
                  {section.content}
                </div>
                {i < legalSections.length - 1 && <Separator className="mt-8 opacity-50" />}
              </div>
            </div>)}

          <div className="pt-8">
            
          </div>
        </div>
      </div>
    </section>;
}